import { css as c, LitElement as d, nothing as p, html as n } from "lit";
import { property as o, customElement as u } from "lit/decorators.js";
import { classMap as g } from "lit/directives/class-map.js";
import { b as v } from "./styles-scZ6dVz-.js";
var f = Object.defineProperty, w = Object.getOwnPropertyDescriptor, s = (e, r, l, a) => {
  for (var i = a > 1 ? void 0 : a ? w(r, l) : r, h = e.length - 1, m; h >= 0; h--)
    (m = e[h]) && (i = (a ? m(r, l, i) : m(i)) || i);
  return a && i && f(r, l, i), i;
};
let t = class extends d {
  constructor() {
    super(...arguments), this.size = "md";
  }
  getInitials(e) {
    if (!e) return "";
    const r = e.trim().split(/\s+/);
    return r.length === 1 ? r[0].substring(0, 2).toUpperCase() : (r[0][0] + r[r.length - 1][0]).toUpperCase();
  }
  render() {
    const e = {
      avatar: !0,
      [this.size]: !0
    };
    return n`
      <div class=${g(e)}>
        ${this.src ? n`<img src=${this.src} alt=${this.alt || this.name || "Avatar"} />` : n`<span>${this.getInitials(this.name || "")}</span>`}
          
        ${this.status ? n`<span class="indicator ${this.status}"></span>` : p}
      </div>
    `;
  }
};
t.styles = [
  v,
  c`
      :host {
        display: inline-block;
        vertical-align: middle;
      }

      .avatar {
        position: relative;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 9999px;
        background-color: var(--r5-avatar-bg, var(--r5-color-primary-100));
        color: var(--r5-avatar-color, var(--r5-color-primary-700));
        font-weight: var(--r5-font-medium);
        overflow: hidden;
        user-select: none;
      }

      /* Sizes */
      .xs { width: 1.5rem; height: 1.5rem; font-size: 0.75rem; }
      .sm { width: 2rem; height: 2rem; font-size: 0.875rem; }
      .md { width: 2.5rem; height: 2.5rem; font-size: 1rem; }
      .lg { width: 3rem; height: 3rem; font-size: 1.125rem; }
      .xl { width: 3.5rem; height: 3.5rem; font-size: 1.25rem; }
      .2xl { width: 4rem; height: 4rem; font-size: 1.5rem; }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: inherit;
      }

      .indicator {
        position: absolute;
        bottom: 0;
        right: 0;
        display: block;
        border-radius: 9999px;
        border: 2px solid var(--r5-bg, white);
        background-color: var(--status-color);
      }
      
      .xs .indicator { width: 0.5rem; height: 0.5rem; }
      .sm .indicator { width: 0.625rem; height: 0.625rem; }
      .md .indicator { width: 0.75rem; height: 0.75rem; }
      .lg .indicator { width: 0.875rem; height: 0.875rem; }
      .xl .indicator { width: 1rem; height: 1rem; }
      .2xl .indicator { width: 1.125rem; height: 1.125rem; }
      
      .online { --status-color: var(--r5-color-success-500); }
      .offline { --status-color: var(--r5-color-neutral-400); }
      .busy { --status-color: var(--r5-color-danger-500); }
      .away { --status-color: var(--r5-color-warning-500); }
    `
];
s([
  o()
], t.prototype, "src", 2);
s([
  o()
], t.prototype, "alt", 2);
s([
  o()
], t.prototype, "name", 2);
s([
  o({ reflect: !0 })
], t.prototype, "size", 2);
s([
  o({ reflect: !0 })
], t.prototype, "status", 2);
t = s([
  u("ark-avatar")
], t);
export {
  t as A
};
//# sourceMappingURL=ark-avatar-Cugmmpr6.js.map
